import * as mtaRequestActions from './mtaRequestReducer';
import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';

const defaultIncludes = ['responded_by', 'policy'];

const clearMtaRequest = () => {
  return {
    type: mtaRequestActions.CLEAR_MTA_REQUEST,
  };
};

const isSubmitting = (status) => {
  return {
    type: mtaRequestActions.IS_SUBMITTING,
    status,
  };
};

const getMtaRequest = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint = 'mta-requests/' + id;
    endpoint += queryString(includes);

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: mtaRequestActions.SET_MTA_REQUEST,
          data: response.data,
        });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.reference,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

// const createMtaRequest = (resource, publicRequest = true, redirect = false) =>  {
//   return (dispatch) => {
//     dispatch(isSubmitting(true));
//     return Axios.post((publicRequest ? 'public/' : '/') + 'complaint', resource)
//       .then((response) => {
//         dispatch(isSubmitting(false));
//         toastr.success('Complaint sent', 'Your complaint was submitted to Just Travel');
//
//         if (redirect) {
//           dispatch(push('/complaint/' + response.data.data.id));
//         }
//         return true;
//       })
//       .catch((error) => {
//         dispatch(isSubmitting(false));
//         handleErrorResponse(error, 'There was an error creating your complaint');
//       });
//   };
// };

const respondToMtaRequest = (resourceId) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post('/mta-requests/' + resourceId + ':respond')
      .then(() => {
        dispatch(isSubmitting(false));
        toastr.success('MTA Request marked as responded');
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error setting responded by');
      });
  };
};

export const actions = {
  clearMtaRequest,
  getMtaRequest,
  respondToMtaRequest,
};
